<div class="justify-content-center mb-4 carousel-container">
  <div class="d-flex justify-content-end mb-2">
    <div class="buttons-container">
      <div class="toggle-container">
        <button class="toggle-button" [class.active]="isViewedCards" (click)="toggleViewedCard(true)">
          <img class="mr-10px"
               [src]="isViewedCards ? 'assets/viewed-favorites/all-viewed-active.svg' : 'assets/viewed-favorites/all-viewed.svg'">
          {{ 'cards_library.viewed_cards' | translate }}
        </button>
        <button class="toggle-button" [class.active]="!isViewedCards" (click)="toggleViewedCard(false)">
          <img class="mr-10px"
               [src]="isViewedCards ? 'assets/viewed-favorites/favorite.svg' : 'assets/viewed-favorites/favorite-active.svg'">
          {{ 'cards_library.favorites' | translate }}
        </button>
      </div>
      @if (isShowClearHistoryButton()) {
        <button aria-hidden="false" class="new-clear-history-button" (click)="confirmClearHistory($event)">{{ 'cards_library.clear_history' | translate }}</button>
      }
    </div>
  </div>
  @if (!isLoading) {
    @if (isViewedCards && cardsHistory.length === 0) {
      <div class="history-container">
        <p class="history-text">{{ 'cards_library.no_viewed_cards_available' | translate }}</p>
      </div>
    } @else if (!isViewedCards && favoriteCards.length === 0) {
      <div class="history-container">
        <p class="history-text">{{ 'cards_library.no_favorites_available' | translate }}</p>
      </div>
    }
  }
  @if (!isListView) {
    <div class="cards-history-grid-container">
      @if (isViewedCards) {
        @for (cardHistory of cardsHistory; track cardsHistory) {
          <app-single-card-grid [singleCard]="cardHistory"
                                [isFavoriteMap]="isFavoriteMap"
                                (deleteCardFromHistory)="onDelete(cardHistory.userCardResponse.id, cardHistory.id, $event)"
                                [isDeleteButtonFromHistoryActive]="true"
                                [isStarActive]="true"
                                [isCardActive]="cardHistory.userCardResponse.active"
          ></app-single-card-grid>
        }
      } @else {
        @for (favoriteCard of favoriteCards; track favoriteCard) {
          <app-single-card-grid [singleCard]="favoriteCard"
                                [isFavoriteMap]="isFavoriteMap"
                                [isDeleteButtonFromHistoryActive]="false"
                                [isStarActive]="true"
                                [isCardActive]="favoriteCard.userCardResponse.active"
          ></app-single-card-grid>
        }
      }
    </div>
  } @else {
    @if (isViewedCards ? cardsHistory.length > 0 : favoriteCards.length > 0) {
                      <div class="member-info-container member-info-text">{{ 'my_team.member_info' | translate }}</div>
      <div class="line-container"></div>
    }
    @if (isViewedCards) {
      @for (cardHistory of cardsHistory; track cardsHistory) {
        <div class="line-container-active"></div>
        <app-single-card-list [singleCard]="cardHistory"
                              [isFavoriteMap]="isFavoriteMap"
                              (deleteCard)="onDelete(cardHistory.userCardResponse.id, cardHistory.id, $event)"
                              [isDeleteButtonFromHistoryActive]="true"
                              [isStarActive]="true"
                              [isCardActive]="cardHistory.userCardResponse.active"
        ></app-single-card-list>
        <div class="line-container-active"></div>
      }
    } @else {
      @for (favoriteCard of favoriteCards; track favoriteCard) {
        <div class="line-container-active"></div>
        <app-single-card-list [singleCard]="favoriteCard"
                              [isFavoriteMap]="isFavoriteMap"
                              [isDeleteButtonFromHistoryActive]="false"
                              [isStarActive]="true"
                              [isViewedCard]="isViewedCards"
                              [isCardActive]="favoriteCard.userCardResponse.active"
        ></app-single-card-list>
        <div class="line-container-active"></div>
      }
    }
    @if (isViewedCards ? cardsHistory.length > 0 : favoriteCards.length > 0) {
      <div class="member-info-container-footer"></div>
    }
  }
  @if (isViewedCards ? cardsHistory.length > 0 : favoriteCards.length > 0) {
    @if (isViewedCards && viewedCardsPage < viewedCardsTotalPages - 1) {
      <div class="d-flex justify-content-center mt-4 flex-direction-row gap-10px">
        @if (!isLoading) {
          <button class="load-history-button">{{ 'my_team.load_more' | translate }}</button>

          <div class="search-loader">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </div>
    }
    @if (!isViewedCards && favoriteCardsPage < favoriteCardsTotalPages - 1) {
      <div class="d-flex justify-content-center mt-4 flex-direction-row gap-10px">
        @if (!isLoading) {
          <button class="load-history-button">{{ 'my_team.load_more' | translate }}</button>

          <div class="search-loader">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
